export default __webpack_public_path__ + "static/security-1-f5a9b4e1488ae4188be7a205ceb88670.webp";